<template>
  <section class="clients-filters">
    <div class="section-title">
      <span @click="isOpen = !isOpen">
        {{ $t('clients.listing.filters.title') }}
        <font-awesome-icon :icon="isOpen ? 'sort-up' : 'sort-down'" />
      </span>
    </div>
    <div v-show="isOpen">
      <div class="filter-inputs">
        <div class="filters-label">
          {{ $t('clients.listing.labels.clientStatusFilter') | uppercase }}
        </div>
        <TolSelect
          :options="clientStatusesForSelect"
          :selected="clientsFilterPreference"
          :placeholder="$t('clients.listing.labels.clientStatusFilter')"
          @change="onClientsStatusFilterChange"
        />
        <div class="date-range-label">
          {{ $t('clients.listing.labels.clientTypeFilter') | uppercase }}
        </div>
        <TolSelect
          :options="clientTypesForSelect"
          :selected="clientsTypeFilterPreference"
          :placeholder="$t('clients.listing.labels.clientTypeFilter')"
          @change="onClientsTypeFilterChange"
        />
      </div>
    </div>
  </section>
</template>
<script>
import TolSelect from '@/app/components/TolSelect';
import {
  ClientsListingGetters,
  ClientsListingActions
} from '@/app/features/clients/features/clients-listing/clients-listing.keys';
export default {
  components: {
    TolSelect
  },
  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    clientsFilterPreference() {
      const selectedValue = this.$store.getters[ClientsListingGetters.ClientsFilterPreference];
      let selectedFilterArray = [];
      if (selectedValue) {
        selectedFilterArray.push({
          label: this.$t('clients.listing.filters.clientStatuses.' + selectedValue),
          value: selectedValue
        });
      }
      return selectedFilterArray;
    },
    clientsTypeFilterPreference() {
      const selectedValue = this.$store.getters[ClientsListingGetters.ClientsTypeFilterPreference];
      let selectedFilterArray = [];
      if (selectedValue) {
        selectedFilterArray.push({
          label: this.$t('clients.listing.filters.clientTypes.' + selectedValue),
          value: selectedValue
        });
      }
      return selectedFilterArray;
    },
    clientStatusesForSelect() {
      let returnValue = [];
      Object.keys(this.$t('clients.listing.filters.clientStatuses')).forEach(arg => {
        returnValue.push({
          label: this.$t('clients.listing.filters.clientStatuses.' + arg),
          value: arg
        });
      });
      return returnValue;
    },
    clientTypesForSelect() {
      let returnValue = [];
      Object.keys(this.$t('clients.listing.filters.clientTypes')).forEach(arg => {
        returnValue.push({
          label: this.$t('clients.listing.filters.clientTypes.' + arg),
          value: arg
        });
      });
      return returnValue;
    }
  },
  methods: {
    onClientsStatusFilterChange(selectedValue) {
      this.$store.dispatch(ClientsListingActions.ClientsFilterPreferenceUpdate, selectedValue);
    },
    onClientsTypeFilterChange(selectedValue) {
      this.$store.dispatch(ClientsListingActions.ClientsTypeFilterPreferenceUpdate, selectedValue);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';
.clients-filters {
  background-color: $background-level-2;

  .section-title {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.22px;
    line-height: 25px;
    margin-bottom: 20px;
    padding: 60px;
    display: flex;
    justify-content: space-between;
    > span {
      cursor: pointer;
    }
  }

  .filter-inputs {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0px 60px 60px 60px;

    .filters-label {
      padding-bottom: 5px;
      display: inline-block;
      margin: 0 10px;
    }
  }
}
</style>
